module.exports = __webpack_public_path__ + "static/media/pragati-tag.33986ad8.svg";